import React, {useEffect, useMemo} from 'react';
import {useRecoilValue} from "recoil";
import axios from "axios";
import {DictType} from "./model";
import ko from "./i18n/ko";
import en from "./i18n/en";
import localeState from "./recoil/locale";
import {IntlProvider} from "react-intl";
import styled from "styled-components";
import {RouterProvider, createBrowserRouter, RouteObject} from "react-router-dom";
import ErrorBoundaryLayout from "./component/error/ErrorBoundaryLayout";
import {Error404View} from "./component/error/ErrorView";
import HomeView from "./view/home/HomeView";
import {Toaster} from "react-hot-toast";
import PrivacyPolicyView from "./view/PrivacyPolicyView";
import TermsOfServiceView from "./view/TermsOfServiceView";

const RouterInfo: RouteObject[] = [
    {
        path: "/",
        element: <ErrorBoundaryLayout />,
        children: [
            {
                path: "",
                element: <HomeView />
            },
            {
                path: "/terms-of-service",
                element: <TermsOfServiceView />
            },
            {
                path: "/privacy-policy",
                element: <PrivacyPolicyView />
            },
            {
                path: "*",
                element: <Error404View />,
            }
        ]
    }
];

const RouterObject = createBrowserRouter(RouterInfo);

const AppWrapper: React.FC = () => {
  const locale = useRecoilValue(localeState);

  const messages: DictType<Record<string, string>> = useMemo(() => {
    return {"ko": ko, "en": en};
  }, []);

  useEffect(() => {
    axios.defaults.headers.common["X-SITEBUNNY-LANG"] = locale;
  }, [locale])

  return (
      <IntlProvider locale={locale} messages={messages[locale]}>
        <App />
      </IntlProvider>
  );
};

const App: React.FC = () => {
  return (
      <div>
        <AppStyle>
          <RouterProvider router={RouterObject} />
        </AppStyle>
        <Toaster position="top-right"
                 containerStyle={{top: "15px"}}
                 toastOptions={{
                     style: {
                         maxWidth: "800px"
                     },
                 }}
        />
      </div>
  )
}

const AppStyle = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  width: 100vw;
  overflow: hidden;
`

export default AppWrapper;
